/**
 * Removes bad data from the input array and returns a clean array
 *
 * @param array
 * @returns {*}
 */
export const cleanArrayFieldData = (array) => {
    return array.filter(item => item !== false && item !== '');
}

export const isInIframe = () => {
	try {
		// if we throw an exception when trying to access top property it's because of some Cross-Origin security crap.
		let docuWocu = window.top.document;
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
}

export const cleanFalseyProperty = (property) => {
	if (!property || property === 'false') {
		return '';
	}

	return property
}

/**
 * Asynchronously confirms an action with a user and executes a callback function if confirmed.
 * @param {string|null} [message] - The confirmation message displayed to the user.
 * @param {Function} [callback=async () => {}] - The callback function to be executed if the user confirms the action.
 * @param {...any} args - Additional arguments to be passed to the callback function.
 * @returns {Promise<any>} - A promise that resolves with the result of the callback function if the action is confirmed, otherwise undefined.
 */
export const confirmAsync = async (message = null, callback = async () => {}, ...args) => {
	if (window.confirm(message ??  "Are you sure you want to perform this action?")) {
		return await callback(...args);
	}
}

export const confirmSync = async (message = null, callback = () => {}, ...args) => {
	if (window.confirm(message ??  "Are you sure you want to perform this action?")) {
		return callback(...args);
	}
}

/** converts a boolean-like string (e.g. '1' or 'true') to an actual boolean
 *
 * @param string
 * @returns {boolean}
 */
export const stringAsBoolean = (string) => {
	return string === 1 || string === '1' || string === 'true' || string === true;
}

export const jsonParse = (o) => {
	if (typeof o == 'object') {
		return Object.assign({}, o); //assume we're creating a new obj
	}

	try {
		return JSON.parse(o);
	} catch (e) {
		return o;
	}
}

export function cleanseLocalStorage() {
	const prefixesToRemove = ['ug-', 'DataTables', '__ug', 'userguiding', 'user-guiding'];
	const keysToRemove = [];

	// Identify keys to remove
	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (prefixesToRemove.some(prefix => key.startsWith(prefix))) {
			keysToRemove.push(key);
		}
	}

	// Remove identified keys
	keysToRemove.forEach(key => {
		try {
			localStorage.removeItem(key);
			console.log(`Removed item with key: ${key}`);
		} catch (e) {
			console.error(`Failed to remove item with key: ${key}`, e);
		}
	});

	console.log(`Cleaned up ${keysToRemove.length} items from localStorage`);
}